import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        cart: [],
    },
    reducers: {

        addToCart: (state, action) => {
            const itemInCart = state.cart.find(((item) => item.Id === action.payload.Id));

            if(itemInCart)
              {
           
                alert("Item Already in the cart");
              }
            else
               {
                state.cart.push({ ...action.payload, quantity: 1 });
               }  
        },

        incrementQuantity: (state, action) => {
            const item = state.cart.find(((item) => item.Id === action.payload));
            item.quantity++;
        },

        decrementQuantity: (state, action) => {
            const item = state.cart.find((item) => item.Id === action.payload);

            if(item.quantity === 1)
              {
                 item.quantity = 1
              }
            else 
              {
                  item.quantity-- ;
              }  
        },

        removeItem: (state, action) => {
            const removeItem = state.cart.filter((item) => item.Id !== action.payload)
            state.cart = removeItem;
        },
        // {
        //     state.push(action.payload)
        // },

        // remove(state, action)
        // {
        //     state = state.filter(item => item.Id !== action.payload)
        // },
    },
});

export const cartReducer = cartSlice.reducer;
export const {
    addToCart,
    incrementQuantity,
    decrementQuantity,
    removeItem,
} = cartSlice.actions;


// export const { add, remove } = cartSlice.actions;

// export default cartSlice.reducer;
